import { projectConfig } from "../project-info/projectConfig";

export function errorAlert(message, title = projectConfig.alertTitle) {
  // eslint-disable-next-line no-alert
  alert(`${title}: ${message}`);
}
